import request from '@/utils/request'
import { getToken } from '../utils/auth'
// 查询绑定设备数据
export function querybinddevice (params, data) {
  params.token = getToken()
  return request({
    url: '/querybinddevice',
    method: 'post',
    params,
    data
  })
}
// 按照组织ID查找设备
export function querybinddevicebyoid (params, data) {
  params.token = getToken()
  return request({
    url: '/querybinddevicebyoid',
    method: 'post',
    params,
    data
  })
}
// 搜索设备
export function searchunbinddevice (data) {
  return request({
    url: '/searchunbinddevice',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 设备绑定家庭(房间)
export function binddevicetohome (data) {
  return request({
    url: '/binddevicetohome',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 设备绑定服务对象
export function binddevicetoperson (data) {
  return request({
    url: '/binddevicetoperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新家庭设备信息
export function updatedevicetohome (data) {
  return request({
    url: '/updatedevicetohome',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新人员设备信息
export function updatedevicetoperson (data) {
  return request({
    url: '/updatedevicetoperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除解绑家庭设备
export function deletedevicetohome (data) {
  return request({
    url: '/deletedevicetohome',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除解绑人员设备
export function deletedevicetoperson (data) {
  return request({
    url: '/deletedevicetoperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 根据ids查询设备信息
export function querydevicebydids (data) {
  return request({
    url: '/querydevicebydids',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 根据imei查询设备信息
export function querydevicebyimei (data) {
  return request({
    url: '/querydevicebyimei',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 根据主设备查询子设备信息
export function querysubdevice (data) {
  return request({
    url: '/querysubdevice',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 子机设备绑定，默认绑定床位(bind_type = 1) 养老院
export function bindsubdevice (data) {
  return request({
    url: '/bindsubdevice',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 解绑子设备 养老院
export function unbindsubdevice (data) {
  return request({
    url: '/unbindsubdevice',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查看子机设备绑定状态
export function querysubdevicebind (data) {
  return request({
    url: '/querysubdevicebind',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 添加子机设备
export function addsubdevice (data) {
  return request({
    url: '/addsubdevice',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 编辑子机设备
export function updatesubdevice (data) {
  return request({
    url: '/updatesubdevice',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除子机设备
export function deletesubdevice (data) {
  return request({
    url: '/deletesubdevice',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 设备语音通知
export function addvoicemsg (data) {
  return request({
    url: '/addvoicemsg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 按设备类型查找当前组织下设备数量
export function queryorgdevicecount (data) {
  return request({
    url: '/queryorgdevicecount',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询网关设备电话本白名单
export function querydevicephonebook (data) {
  return request({
    url: '/querydevicephonebook',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 新增网关设备电话本白名单
export function adddevicephonebook (data) {
  return request({
    url: '/adddevicephonebook',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 修改网关设备电话本白名单
export function updatedevicephonebook (data) {
  return request({
    url: '/updatedevicephonebook',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除网关设备电话本白名单
export function deletedevicephonebook (data) {
  return request({
    url: '/deletedevicephonebook',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询已绑定设备
export function searchdevice (data) {
  return request({
    url: '/searchdevice',
    method: 'post',
    params: { token: getToken(), size: data.size, page: data.page },
    data: {
      lessdeviceid: data.lessdeviceid,
      dtype: data.dtype
    }
  })
}
// 查询FM信息，支持分页
export function queryfminfo (data) {
  return request({
    url: '/queryfminfo',
    method: 'post',
    params: { token: getToken(), size: data.size, page: data.page },
    data: {
      did: data.did
    }
  })
}
// 新增FM
export function addfminfo (data) {
  return request({
    url: '/addfminfo',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除FM信息
export function deletefminfo (data) {
  return request({
    url: '/deletefminfo',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询设备FM设置，支持分页
export function querydevicefminfo (data) {
  return request({
    url: '/querydevicefminfo',
    method: 'post',
    params: { token: getToken(), size: data.size, page: data.page },
    data: {
      did: data.did
    }
  })
}
// 设置添加设备FM
export function addfmdevice (data) {
  return request({
    url: '/addfmdevice',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除设备FM信息
export function deletedevicefminfo (data) {
  return request({
    url: '/deletedevicefminfo',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查找设备 mqtttopic 信息
export function querydevicemqttbyimei (data) {
  return request({
    url: '/querydevicemqttbyimei',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更换设备
export function changedevicebyimei (data) {
  return request({
    url: '/changedevicebyimei',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询设备历史位置
export function querydevicehistoryposition (data) {
  return request({
    url: '/querydevicehistoryposition',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 901设置设备发生指令
export function sendcommand (data) {
  return request({
    url: '/sendcommand',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 获取设备位置
export function querydeviceposition (data) {
  return request({
    url: '/querydeviceposition',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 设置时长
export function setdevicealarminterval (data) {
  return request({
    url: '/setdevicealarminterval',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 获取设备设置信息
export function querycommand (data) {
  return request({
    url: '/querycommand',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 获取录音列表
export function querydevicerecord (data) {
  return request({
    url: '/querydevicerecord',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 获取设备数据日志
export function querydeviceinfolog (data) {
  return request({
    url: '/querydeviceinfolog',
    method: 'post',
    params: { token: getToken() },
    data
  })
}

// 获取设备设置日志
export function querydevicesetlog (data) {
  return request({
    url: '/querydevicesetlog',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 微聊接口
// 获取设备单聊querydevicemsg
export function querydevicemsg (params, data) {
  params.token = getToken()
  return request({
    url: '/querydevicemsg',
    method: 'post',
    params,
    data
  })
}
// 使用设备ID获取人员信息
export function querypersonbydid (data) {
  return request({
    url: '/querypersonbydid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 使用账号ID获取平台人员信息
export function queryorgpersonbyuid (data) {
  return request({
    url: '/queryorgpersonbyuid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 发送设备单聊
export function adddevicemsg (data) {
  return request({
    url: '/adddevicemsg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 获取群聊信息
export function querygroupmsg (params, data) {
  params.token = getToken()
  return request({
    url: '/querygroupmsg',
    method: 'post',
    params,
    data
  })
}
// 发送群聊信息
export function addgroupmsg (data) {
  return request({
    url: '/addgroupmsg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 获取群聊群组
export function querymsggroup (data) {
  return request({
    url: '/querymsggroup',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 创建群聊群组
export function addmsggroup (data) {
  return request({
    url: '/addmsggroup',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 修改群聊群组
export function updatemsggroup (data) {
  return request({
    url: '/updatemsggroup',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除群聊群组
export function deletemsggroup (data) {
  return request({
    url: '/deletemsggroup',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 获取群聊群组成员
export function querymsggroupmember (params, data) {
  params.token = getToken()
  return request({
    url: '/querymsggroupmember',
    method: 'post',
    params,
    data
  })
}
// 创建群聊群组成员
export function addmsggroupmember (data) {
  return request({
    url: '/addmsggroupmember',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 修改群聊群组成员
export function updatemsggroupmember (data) {
  return request({
    url: '/updatemsggroupmember',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除群聊群组成员
export function deletemsggroupmember (data) {
  return request({
    url: '/deletemsggroupmember',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 获取围栏列表
export function devicecirclelist (data) {
  return request({
    url: '/devicecircle/list',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 新增围栏
export function devicecircleadd (data) {
  return request({
    url: '/devicecircle/add',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新围栏
export function devicecircleupdate (data) {
  return request({
    url: '/devicecircle/update',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除围栏
export function devicecircledelete (data) {
  return request({
    url: '/devicecircle/delete',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/device.js